// SUN-283 item 6a — picking an account on Add / Edit Contact: an account with a GSTIN makes the contact B2B.
// Only the user's pick changes the type (opening Edit never does). If a later pick has no GSTIN, the type
// the user had before the auto-B2B comes back — unless they typed a GSTIN meanwhile.
import { partyCustomerType } from '@/utils/partyGst';

type PickForm = { accountId: string; customerType: string; gstin?: string };

/** `auto.current` = the type before an account pick switched it to B2B (null = the type is the user's own). */
export function pickContactAccount<T extends PickForm>(
  form: T,
  accountId: string,
  accounts: { id: string; gstin?: string | null }[],
  auto: { current: string | null },
): T {
  const account = accounts.find((a) => a.id === accountId);
  const next = { ...form, accountId };
  if (account && partyCustomerType({ gstin: account.gstin }) === 'b2b') {
    if (form.customerType !== 'b2b') { auto.current = form.customerType; next.customerType = 'b2b'; }
  } else if (auto.current !== null) {
    if (!(form.gstin ?? '').trim()) next.customerType = auto.current;
    auto.current = null;
  }
  return next;
}
